import type { IaHandoffBin, Lead } from '../../types';

const BINS: IaHandoffBin[] = ['human', 'inactive', 'lowintent', 'optout', 'toxic'];

/** Destino visual da animação de sucção (F4.5) — alinha com `iaConversationContext.handoffBin` ou *human*. */
export function resolveSuckHandoffTarget(lead: Lead): IaHandoffBin {
  return lead.iaConversationContext?.handoffBin ?? 'human';
}

export function countLeadsByHandoffBin(leads: readonly Lead[]): Record<IaHandoffBin, number> {
  const out: Record<IaHandoffBin, number> = { human: 0, inactive: 0, lowintent: 0, optout: 0, toxic: 0 };
  for (const l of leads) {
    const b = l.iaConversationContext?.handoffBin;
    if (b && BINS.includes(b)) out[b] += 1;
  }
  return out;
}

export function groupLeadsByHandoffBin(leads: readonly Lead[]): Record<IaHandoffBin, Lead[]> {
  const out: Record<IaHandoffBin, Lead[]> = { human: [], inactive: [], lowintent: [], optout: [], toxic: [] };
  for (const l of leads) {
    const b = l.iaConversationContext?.handoffBin;
    if (b && BINS.includes(b)) out[b].push(l);
  }
  return out;
}
